import { useId, type SubmitEvent } from "react";
import { Trans, useTranslation } from "react-i18next";

import { useCreatePasswordResetRequest } from "@/api/bale";
import { Anchor } from "@/components/Anchor";
import { Button } from "@/components/Button";
import { Form } from "@/components/Form";
import { Input } from "@/components/Input";
import { Success } from "@/components/Success";

export function ForgotPasswordForm() {
  const { t } = useTranslation();
  const createPasswordResetRequest = useCreatePasswordResetRequest();

  function handleSubmit(e: SubmitEvent<HTMLFormElement>) {
    const form = new FormData(e.currentTarget);
    const email = form.get("email")! as string;
    createPasswordResetRequest.mutate({
      data: { email },
    });
  }
  const labelId = useId();

  return (
    <div className="flex flex-col items-center">
      <div className="mb-6 flex flex-col gap-2">
        <h2 className="text-center font-title whitespace-nowrap" id={labelId}>
          {t("forgot-password-title")}
        </h2>
        {createPasswordResetRequest.isSuccess ? (
          <Success className="flex flex-col gap-2">
            <Trans i18nKey="forgot-password-success" />
          </Success>
        ) : (
          <p className="font-disinterest">
            <Trans
              i18nKey="forgot-password-disclaimer"
              values={{ email: import.meta.env.VITE_SUPPORT_EMAIL }}
              components={{
                mailtoLink: <Anchor href={`mailto:${import.meta.env.VITE_SUPPORT_EMAIL}`} />,
              }}
            />
          </p>
        )}
      </div>
      <Form
        error={createPasswordResetRequest.error}
        onSubmit={handleSubmit}
        className="flex w-full flex-col gap-6"
        aria-labelledby={labelId}
      >
        <Input
          name="email"
          type="email"
          required
          placeholder={t("email")}
          onChange={() => createPasswordResetRequest.reset()}
          disabled={createPasswordResetRequest.isPending}
        />
        <div className="flex flex-col gap-2">
          <Button type="submit" disabled={createPasswordResetRequest.isPending || createPasswordResetRequest.isSuccess}>
            {t("forgot-password-action")}
          </Button>
        </div>
      </Form>
    </div>
  );
}
